import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-challenge-rules-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './challenge-rules-content.component.html',
  styleUrl: './challenge-rules-content.component.scss'
})
export class ChallengeRulesContentComponent {
  @Input() rulesPdfUrl: string = '';
  @Input() rulesPreviewUrl: string | null = null;
  @Input() loadingPreview: boolean = false;
  /** When true (e.g. preview mode), Preview and Download PDF buttons are disabled. */
  @Input() disableActions: boolean = false;
  @Output() downloadClick = new EventEmitter<void>();
  @Output() previewClick = new EventEmitter<void>();

  constructor(private sanitizer: DomSanitizer) {}

  get rulesPreviewSafeUrl(): SafeResourceUrl | null {
    return this.rulesPreviewUrl
      ? this.sanitizer.bypassSecurityTrustResourceUrl(this.rulesPreviewUrl)
      : null;
  }

  onDownloadClick(): void {
    if (this.disableActions) return;
    this.downloadClick.emit();
  }

  onPreviewClick(): void {
    if (this.disableActions) return;
    this.previewClick.emit();
  }
}


